// extracted by mini-css-extract-plugin
export var productImage = "_rk-1";
export var viewLink = "_rk-2";
export var wishlistItem = "_rk-0";